// extracted by mini-css-extract-plugin
export default {"modalRoot":"ScreenSizeModal_modalRoot__QgwSD","contentContainer":"ScreenSizeModal_contentContainer__Ed0XJ","warningIcon":"ScreenSizeModal_warningIcon__JvPOo"};